import * as uuid from 'uuid';
import type { Omit } from 'js/sign-components/common/ts-utils';
import type { CCRole, CCEmail } from '../types/cc';
import { recipientTypes, RecipientDeliveryTypes } from '../types/recipient';
import type {
  Attachment,
  FaxRecipient,
  Role,
  Signer,
} from '../types/recipient';

export const generateCCRole = (payload: Partial<CCRole> = {}): CCRole => ({
  id: uuid.v4(),
  type: 'ccRole',
  name: '',
  ...payload,
});

export const generateCCEmail = (payload: Partial<CCEmail> = {}): CCEmail => ({
  id: uuid.v4(),
  type: 'ccEmail',
  email: '',
  ...payload,
});

export const generateAttachment = (
  payload: Partial<Omit<Attachment, 'id'>> = {},
): Attachment => ({
  id: uuid.v4(),
  name: '',
  instructions: '',
  required: false,
  ...payload,
});

export const generateSigner = (payload: Partial<Signer> = {}): Signer => ({
  id: uuid.v4(),
  type: recipientTypes.Signer,
  email: '',
  name: '',
  attachments: [],
  accessCode: '',
  smsAuthNumber: '',
  smsDeliveryMobileNumber: '',
  deliveryType: RecipientDeliveryTypes.Email,
  ...payload,
});

export const generateRole = (payload: Partial<Role> = {}): Role => ({
  id: uuid.v4(),
  type: recipientTypes.Role,
  name: '',
  attachments: [],
  ...payload,
});

export const generateFaxRecipient = (
  payload: Partial<FaxRecipient> = {},
): FaxRecipient => ({
  id: uuid.v4(),
  type: recipientTypes.Fax,
  fax: '',
  ...payload,
});
